import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {downloadDeals, getActivePlans, getPlans, getProcessedGoods, getProfitDay} from "./dashboardActions";
import {Plan} from "../../../models/Plan";


interface IProcessedGoodsPayload {
    sea: Record<string, string>
    calcul: Record<string, string>
}

interface IPlansPayload {
    plans: Plan[]
}

interface IActivePlansPayload {
    activePlans: Omit<Plan, 'end_time'>[]
}

interface IProfitDay {
    today: {
        profit: number
        date: string
    }
    yesterday: {
        profit: number
        date: string
    }
    tommorow: {
        date: string
    }
}

interface IDashboardState extends IPlansPayload,
    IActivePlansPayload {
    success: boolean
    isLoading: boolean
    profit: IProfitDay
    processedGoods: Record<string, string>
}

const initialState: IDashboardState = {
    success: false,
    plans: [],
    activePlans: [],
    profit: {} as IProfitDay,
    processedGoods: {},
    isLoading: false
}

export const dashboardSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: {
        [downloadDeals.pending.type]: (state) => {
            state.success = false
        },
        [downloadDeals.fulfilled.type]: (state) => {
            state.success = true
        },
        [getPlans.pending.type]: (state) => {
            state.isLoading = true
        },
        [getPlans.fulfilled.type]: (state, {payload}: PayloadAction<IPlansPayload>) => {
            state.isLoading = false
            state.plans = payload.plans
        },
        [getActivePlans.pending.type]: (state) => {
            state.isLoading = true
        },
        [getActivePlans.fulfilled.type]: (state, {payload}: PayloadAction<IPlansPayload>) => {
            state.isLoading = false
            state.activePlans = payload.plans
        },
        [getProfitDay.pending.type]: (state) => {
            state.isLoading = true
        },
        [getProfitDay.fulfilled.type]: (state, {payload}: PayloadAction<IProfitDay>) => {
            state.isLoading = false
            state.profit = payload
        },
        [getProcessedGoods.pending.type]: (state) => {
            state.isLoading = true
        },
        [getProcessedGoods.fulfilled.type]: (state, {payload}: PayloadAction<IProcessedGoodsPayload>) => {
            state.processedGoods = payload.calcul
            state.isLoading = false
        }
    }
})

export default dashboardSlice.reducer
